import { isEqual } from 'lodash'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { routes } from '~config'
import { useAuth } from '~context/AuthContext'
import { Button, PopIn, Text } from '~design-system'

const UpdatePasswordPopin = () => {
  const {
    isAuthenticated,
    authState: { user },
  } = useAuth()
  const navigate = useNavigate()
  
  // Ne pas afficher si les CGU ne sont pas acceptées
  const hasCguAccepted = user?.cguAccepted !== false
  
  const needToUpdatePassword =
    isAuthenticated() && 
    isEqual(user?.hasValidPassword, false) &&
    hasCguAccepted
    
  const [isVisible, setIsVisible] = useState(needToUpdatePassword)

  // Réagir aux changements (notamment après acceptation des CGU)
  useEffect(() => {
    if (needToUpdatePassword) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [needToUpdatePassword])

  return (
    <PopIn open={isVisible} closable onClose={() => setIsVisible(false)}>
      <PopIn.Title textAlign="left">
        Évolution de la politique de mot de passe
      </PopIn.Title>
      <PopIn.Content>
        <Text textColor="greyDarkest" mt={2}>
          La politique de mot de passe a évolué, nous vous invitons à vous
          rendre dans les paramètres et mettre à jour le votre
        </Text>
      </PopIn.Content>

      <PopIn.Actions
        actions={[
          <Button
            key="update-later"
            variant="secondary"
            onClick={() => setIsVisible(false)}
          >
            Changer plus tard
          </Button>,
          <Button
            key="update-now"
            onClick={() => {
              navigate({
                pathname: routes.authenticated.settings,
              })
              setIsVisible(false)
            }}
          >
            Changer mon mot de passe
          </Button>,
        ]}
      />
    </PopIn>
  )
}

export default UpdatePasswordPopin
